import { DeveloperClient, LocalKeyStore, LocalMemoryStore, NEOONEProvider, } from '@neo-one/client-core';
import { Client, LocalUserAccountProvider } from '@neo-one/client-full-core';
export const getClients = async (provider, masterPrivateKey) => {
    const client = new Client({
        memory: new LocalUserAccountProvider({
            keystore: new LocalKeyStore(new LocalMemoryStore()),
            provider: new NEOONEProvider([provider]),
        }),
    });
    const developerClient = new DeveloperClient(provider);
    const masterWallet = await client.providers.memory.keystore.addUserAccount({
        network: provider.network,
        privateKey: masterPrivateKey,
    });
    return { client, developerClient, masterWallet };
};

//# sourceMappingURL=getClients.js.map
